<template>
  <div class="inline-block px-2 max-w-full">
    <div class="flex main--bg rounded px-2 py-1 mb-2 items-center">
      <div class="min-w-0 pr-2">
        <p class="text-white text-zt-xs whitespace-no-wrap truncate">
          <slot />
        </p>
      </div>
      <div class="ml-auto">
        <button class="focus:outline-none" v-on="$listeners">
          <zt-icon name="times" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomChip'
}
</script>

<style scoped>
.main--bg {
  background-color: #898dff;
}
</style>
